import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sub-search-nav-holder"
}
const _hoisted_2 = {
  key: 0,
  ref: "tooltip",
  class: "sub-search-results-label"
}
const _hoisted_3 = {
  key: 1,
  ref: "tooltip",
  class: "sub-search-results-label"
}
const _hoisted_4 = {
  key: 2,
  class: "sub-search-results-label"
}

import _ from 'lodash';
import {QInput, QIcon, QSeparator} from 'quasar';
import {onMounted, ref, watch} from 'vue';
import {useSearchStore} from 'stores/search-store';
import {storeToRefs} from 'pinia';
import {useLayoutStore} from 'stores/layout-store';
import {GrouperLayoutMode} from 'src/services/IodineGrouperService';

import { vOnClickOutside } from '@vueuse/components';



export default /*#__PURE__*/_defineComponent({
  __name: 'SubSearch',
  setup(__props) {

const searchText = ref('');
const expanded = ref(false);
const shortText = ref(false);
const currentSearchLocation = ref('');
const currentSearchText = ref('');
const inputRef = ref<InstanceType<typeof QInput>>();
const searchStore = useSearchStore();
const {currentSubSearchIndex, foundTerms, firstSubSearchPerformed, clearSubSearch} = storeToRefs(searchStore);
const { layoutMode } = storeToRefs(useLayoutStore());

function clear() {
  searchText.value = '';
  searchStore.subSearch(searchText.value);
  searchStore.clearSubSearch = false;
  firstSubSearchPerformed.value = false;
  expanded.value = false;
}

onMounted(() => {
  clear();
});

watch(
    clearSubSearch, (clearSearch) => {
      if(clearSearch) {
        clear();
      }
    }
);

function search() {
  firstSubSearchPerformed.value = true;
  if (validText()) {
    currentSearchLocation.value = searchStore.selectedIndexNode;
    currentSearchText.value = searchText.value;
    shortText.value = false;
    searchStore.subSearch(searchText.value);
  } else {
    shortText.value = true;
  }
}

function nextResult() {
  if (currentSubSearchIndex.value === undefined || currentSubSearchIndex.value === (foundTerms.value.length - 1)) return;
  currentSubSearchIndex.value++;
  searchStore.subSearchNav(foundTerms.value[currentSubSearchIndex.value]);
}

function prevResult() {
  if (currentSubSearchIndex.value === undefined || currentSubSearchIndex.value === 0) return;
  currentSubSearchIndex.value--;
  searchStore.subSearchNav(foundTerms.value[currentSubSearchIndex.value]);
}

function expandSearch() {
  if (!expanded.value) {
    clear();
    expanded.value = !expanded.value;
    setTimeout(() => {
      inputRef?.value?.focus();
    }, 100);
  } else {
    search();
  }
}

function validText(): boolean {
  return !!searchText.value && searchText.value.length >= 2;
}


return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sub-search-holder", {'sub-search-embedded-wrapper': _unref(layoutMode) == _unref(GrouperLayoutMode).consolidated}])
  }, [
    _createVNode(_unref(QInput), {
      dense: "",
      outlined: "",
      modelValue: searchText.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
      class: _normalizeClass(["sub-search-input", {'input-visible': expanded.value }]),
      for: "search-input",
      autocomplete: "off",
      onKeydown: _withKeys(_withModifiers(search, ["prevent"]), ["enter"]),
      ref_key: "inputRef",
      ref: inputRef
    }, {
      append: _withCtx(() => [
        _createVNode(_unref(QSeparator), { vertical: "" }),
        _createVNode(_unref(QIcon), {
          name: "fa-regular fa-magnifying-glass",
          class: "cursor-pointer sub-search-icon",
          onClick: expandSearch
        }, {
          default: _withCtx(() => [
            (!expanded.value)
              ? (_openBlock(), _createBlock(_component_q_tooltip, {
                  key: 0,
                  anchor: "bottom left"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Sub Search")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (expanded.value)
          ? (_openBlock(), _createBlock(_unref(QIcon), {
              key: 0,
              name: "fa-light fa-xmark",
              class: "cursor-pointer sub-search-close-icon",
              onClick: clear
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "class", "onKeydown"]),
    (_unref(firstSubSearchPerformed))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(QIcon), {
            name: "fa-solid fa-chevron-up extra-margin",
            class: _normalizeClass(["sub-search-chevron", {'chevron-disabled': _unref(currentSubSearchIndex) === 0 || _unref(foundTerms).length === 0}]),
            size: "12px",
            onClick: prevResult
          }, {
            default: _withCtx(() => [
              (_unref(currentSubSearchIndex) !== 0 && _unref(foundTerms).length !== 0)
                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                    key: 0,
                    offset: [0, 3]
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Previous Result")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_unref(QIcon), {
            name: "fa-solid fa-chevron-down",
            size: "12px",
            class: _normalizeClass(["sub-search-chevron sub-search-chevron-right", {'chevron-disabled': _unref(currentSubSearchIndex) === _unref(foundTerms).length - 1 || _unref(foundTerms).length === 0}]),
            onClick: nextResult
          }, {
            default: _withCtx(() => [
              (_unref(currentSubSearchIndex) !== _unref(foundTerms).length - 1 && _unref(foundTerms).length !== 0)
                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                    key: 0,
                    offset: [0, 3]
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Next Result")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"]),
          (_unref(foundTerms).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createTextVNode(_toDisplayString(_unref(_).defaultTo(_unref(currentSubSearchIndex), 0) + 1) + " of " + _toDisplayString(_unref(foundTerms).length) + " locations shown from sub search '" + _toDisplayString(currentSearchText.value) + "', within '" + _toDisplayString(currentSearchLocation.value) + "' ", 1),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(_).defaultTo(_unref(currentSubSearchIndex), 0) + 1) + " of " + _toDisplayString(_unref(foundTerms).length) + " locations shown from sub search '" + _toDisplayString(currentSearchText.value) + "', within '" + _toDisplayString(currentSearchLocation.value) + "'", 1)
                  ]),
                  _: 1
                })
              ], 512))
            : _createCommentVNode("", true),
          (_unref(foundTerms).length === 0 && _unref(firstSubSearchPerformed) && !shortText.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode("No results for '" + _toDisplayString(currentSearchText.value) + "', within '" + _toDisplayString(currentSearchLocation.value) + "' ", 1),
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [
                    _createTextVNode("No results for '" + _toDisplayString(currentSearchText.value) + "', within '" + _toDisplayString(currentSearchLocation.value) + "'", 1)
                  ]),
                  _: 1
                })
              ], 512))
            : _createCommentVNode("", true),
          (shortText.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Search term should have at least 2 characters"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_unref(vOnClickOutside), clear]
  ])
}
}

})